<template>
  <div class="table-responsive">
    <table class="table table-hover text-center" id="dataTable" width="100%" cellspacing="0">
      <thead>
        <tr>
          <th>Name</th>
          <th>Username</th>
          <th>Email</th>
          <th>Last Location</th>
          <th>Access From</th>
          <th>Type</th>
          <th>Time</th>
        </tr>
      </thead>
      <tbody>
        <tr  v-if="isLoader" id="table_row" >
          <td colspan="16">
            <b-skeleton-wrapper >
                <b-skeleton height="40px" ></b-skeleton>   
                <b-skeleton height="40px"></b-skeleton>  
                <b-skeleton height="40px"></b-skeleton>                                     
            </b-skeleton-wrapper> 
          </td>
        </tr>
        <tr v-show="!isLoader" v-for="user in users" :user="user" :key="user.slug">
          <!-- username -->
          <td>
            {{ user.first_name }} {{ user.last_name }}
            <!-- <router-link :to="'/users/' + user.slug + '/posts'">{{ user.first_name }} {{ user.last_name }}</router-link> -->
          </td>

          <!-- name -->
          <td>
            {{ user.user_name }}
            <!-- <router-link :to="'/users/' + user.slug + '/posts'">{{ user.user_name }}</router-link> -->
          </td>

          <!-- email -->
          <td>{{ user.email }}</td>

          <!-- last location -->
          <td>{{ user.location }}</td>
          <td>{{ user.type }}</td>

          <!-- last login time -->
          <td>{{ user.time_type }}</td>
          <!-- last logout time -->
          <td>{{ user.last_visited }}</td>
        </tr>
      </tbody>
    </table>
    <h5 style="text-align: center" v-if="users.length < 1 && !isLoader">
      No data found.
    </h5>
    <paginate v-if="!isLoader" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
      :first-button-text="''" :last-button-text="''" :first-last-button="true"
      :container-class="'pagination pagination-sm float-right mr-4 mt-3 mb-0'" :page-class="'page-item'"
      :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
      :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
  </div>
</template>

<script>
  import moment from "moment";
  import $ from "jquery";
  import roleForm from "./role_form";

  //  Vue.filter('formatDate', function(value) {
  //       if (value!= '0000-00-00 00:00:00' && value!=null ) {
  //           return moment(String(value)).format('DD MMM Y, h:mm:ss a')
  //       }
  //   });

  export default {
    props: ["user", "users", "totalPages", "page","setSkeletonLoader"],
    data: function () {
      return {
        isLoader: true,
      };
    },
    computed: {
      currentPage: {
        get: function () {
          return this.page;
        },
        set: function () { },
      },
      showskLoader:function(){
        // console.log("showskLoader",this.setskeletonLoader);
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      }
    },
    watch:{
      showskLoader: function () {
          this.isLoader = this.setskeletonLoader;
          return this.setskeletonLoader;
      }
    } ,
    methods: {
      setPage(page) {
        this.$emit("setPage", page);
      },
      
    },
  };
</script>